import { useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf';



// Set the workerSrc for PDF.js
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


const PdfViewer = ({ url }) => {
    console.log('PdfViewer', url);
    const [numPages, setNumPages] = useState(null);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    return (
        <Document file={url} onLoadSuccess={onDocumentLoadSuccess}>
            {Array.from(new Array(numPages), (el, index) => (
                <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                />
            ))}
        </Document>
    );
};

const SinglePdfViewer = ({ url }) => {
    const updatedUrl = url.replaceAll('http:', 'https:')
    console.log(updatedUrl)
    return (
        <div style={{ marginBottom: '20px' }}>
            <PdfViewer url={updatedUrl} />
        </div>
    );
};

export default SinglePdfViewer;
